'use client'

import React, { useEffect, useState } from 'react'
import { ErrorMessage as Error } from './input.label.style'

const ErrorMessage = ({
  label = 'Your label',
  breakLineBottom = false,
}: any) => {
  const [anim, setAnim] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      setAnim(true)
    }, 300)
  }, [])

  return (
    <Error toggle={anim} breakLineBottom={breakLineBottom}>
      {label}
    </Error>
  )
}

export default ErrorMessage
